import styled from 'styled-components';
import React from 'react';

const TitleStyle = styled.h1`
  color: ${({ color, theme }) => (color ? color : theme.colors.gray)};
  font-family: 'Poppins', sans-serif;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '30px')};
  font-weight: ${(props) => (props.fontWeigth ? props.fontWeigth : '500')};
  line-height: ${(props) => (props.LineHeight ? props.LineHeight : '40px')};
  padding: ${(props) => (props.padding ? props.padding : '')};
  margin: ${(props) => (props.margin ? props.margin : '')};

  @media (max-width: 1440px) {
    font-size: 1.8rem;
    line-height: 2rem;
  }

  @media (max-width: 1440px) {
    font-size: '24px';
  }
`;

const Title = (props) => <TitleStyle {...props}>{props.children}</TitleStyle>;

export default Title;
